import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Page, PageHeader } from "../../../components/ui";
import { getStripeDetails } from "../../../services/payments";
import ConnectModal from "./connectModal";
import EditModal from "./EditModal";
import AcceptedMethods from "./AcceptedMethods";
import "./payment.css";

/** Gateway card: name, icon, connection state and its action. */
const GatewayCard = ({ name, icon, state, connected, action }) => (
  <section className="ui-card payment-gateway">
    <div className="payment-gateway-head">
      <span className="payment-gateway-icon" aria-hidden="true">
        <i className={icon}></i>
      </span>
      <strong>{name}</strong>
    </div>
    <div className="payment-gateway-foot">
      <span className="payment-gateway-state" data-on={connected || undefined}>
        {state}
      </span>
      {action}
    </div>
  </section>
);

/** Stripe connection and the payment methods accepted (card, Mobile Money). */
const PaymentGateway = () => {
  const { t } = useTranslation();
  const [stripe, setStripe] = useState({});
  const [modal, setModal] = useState(null); // "connect" | "edit"

  useEffect(() => {
    getStripeDetails().then(setStripe);
  }, []);

  const stripeConnected = Boolean(stripe?.secret_key);

  return (
    <Page>
      <ConnectModal
        show={modal === "connect"}
        setShow={(open) => setModal(open ? "connect" : null)}
        updateData={setStripe}
        stripeDetails={stripe}
      />
      <EditModal
        show={modal === "edit"}
        setShow={(open) => setModal(open ? "edit" : null)}
        updateData={setStripe}
        stripeDetails={stripe}
      />

      <PageHeader title={t("Payment Gateways")} />

      <div className="payment-gateways">
        <GatewayCard
          name="Stripe"
          icon="ri-bank-card-line"
          connected={stripeConnected}
          state={stripeConnected ? t("Connected") : t("Disconnected")}
          action={
            <button
              type="button"
              className="ui-btn ui-btn-secondary"
              onClick={() => setModal(stripeConnected ? "edit" : "connect")}
            >
              {stripeConnected ? t("Edit") : t("Connect")}
            </button>
          }
        />
        <AcceptedMethods />
      </div>
      <p className="ui-hint">
        {t("A disabled method is no longer offered on the site and the apps for new payments. Running subscriptions are not affected and payments already started can still finish.")}
      </p>
    </Page>
  );
};

export default PaymentGateway;
